////////No Project Constants
export const COLOR = "light-warm-gray";
export const GID = "no-gid";
export const NAME = "Other";
export const FIREBASE_ID = "no-id";
export const RESOURCE_TYPE = "project";
